<section class="py-4">
  <div class="row align-items-end mx-2">

    <div *ngIf="filtros.dataInicio" class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
      <app-date-interval [(inicio)]="dataInicio" [(fim)]="dataFim" (fimChange)="setWebSocket()" (inicioChange)="setWebSocket()"></app-date-interval>
    </div>


    <div *ngIf="filtros.cliente && listaClientes.length>0" class="col-12 col-lg-6 col-xl-3 pb-2 px-3">
      <label for="pesquisaConsulta">Cliente</label>
      <div class="d-flex align-items-center autocomplete-container">
        <input [inputFormatter]="inputClienteFormat" (selectItem)="addFiltroCliente($event)" [(ngModel)]="clienteSelecionado" [ngbTypeahead]="pesquisaCliente" [resultTemplate]="rt_cliente"
          id="pesquisaCliente" type="text" class="form-control">
        <button *ngIf="clienteSelecionado" (click)="removeFiltroCliente()" class="btn btn-xs btn-danger btn-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <ng-template #rt_cliente let-r="result" let-t="term">
        <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
      </ng-template>
    </div>

    <div  *ngIf="filtros.tipoCliente" class="col-12 col-lg-6 col-xl-3 pb-2 px-3">
      <label for="pesquisaTipo">Tipo Cliente</label>
      <select [(ngModel)]="tipoSelecionado" name="" id="pesquisaTipo" class="form-control">
        <option value=""></option>
        <option *ngFor="let o of listaTipo" value="{{o.nome}}">{{o.nome}}</option>
      </select>
    </div>

    <div class="col-12 col-lg-6 col-xl-3 pb-2 px-3">
      <label for="pesquisaUsuario">Usuário</label>
      <div class="d-flex align-items-center autocomplete-container">
        <input [inputFormatter]="inputUsuarioFormat" (selectItem)="addFiltroUsuario($event)" [(ngModel)]="usuarioSelecionado" [ngbTypeahead]="pesquisaUsuario" [resultTemplate]="rt_usuario"
          id="pesquisaUsuario" type="text" class="form-control">
        <button *ngIf="usuarioSelecionado" (click)="removeFiltroUsuario()" class="btn btn-xs btn-danger btn-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <ng-template #rt_usuario let-u="result" let-t="term">
        <ngb-highlight [result]="u.nome" [term]="t"></ngb-highlight>
      </ng-template>
    </div>



    <div class="col-lg-3 pb-2 px-3">
      <button (click)="webSocketSend()" class="btn btn-success btn-icon">
        <i class="mdi mdi-file-search-outline"></i>
        <span>Gerar relatórios</span>
      </button>
    </div>
  </div>

  <div class="card my-5 mx-4">
    <div class="card-body">

      <div class="text-primary py-2 f-14 fw-500 d-flex align-items-center">
        <i class="mdi mdi-numeric-0-circle-outline f-24 mr-2"></i> Este relatório necessita de uma aplicação extra fornecida pela Union para gerar relatórios complexos
      </div>

      <div *ngIf="!webSocketValidate" class="text-warning py-2 text-center f-14 fw-500 d-flex align-items-center">
        <i class="mdi mdi-loading mdi-spin text-warning f-24 mr-2"></i> Verificando instalação
      </div>

      <ng-container *ngIf="webSocketValidate && !webSocketError">

        <div class="text-success py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-1-circle-outline f-24 mr-2"></i> Tudo certo, você possui a aplicação instalada corretamente!
        </div>

        <div class="text-success py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-2-circle-outline f-24 mr-2"></i> Agora, preenha os filtros acima de acordo com sua necessidade e clique em gerar relatório
        </div>
        <div class="text-success py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-3-circle-outline f-24 mr-2"></i>Se tudo ocorreu corretamente, uma caixa de dialogo apareceu, escolha o diretório onde deseja salvar, confirme e aguarde a execução
        </div>
      </ng-container>

      <ng-container *ngIf="webSocketValidate && webSocketError">

        <div class="text-danger py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-1-circle-outline f-24 mr-2"></i> Aplicação não instalada
        </div>

        <div class="text-info py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-2-circle-outline f-24 mr-2"></i>
          Parar efetuar o download da aplicação <a href="https://s3-sa-east-1.amazonaws.com/siteunion/WebSocketUnion.exe" targe="_blank" class="btn btn-outline-success btn-xs fw-700 px-2 mx-1">clique
            aqui</a>
        </div>

        <div class="text-info py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-3-circle-outline f-24 mr-2"></i> Aguarde o término do download, execute e instale a aplicação
        </div>

        <div class="text-info py-2 f-14 fw-500 d-flex align-items-center">
          <i class="mdi mdi-numeric-4-circle-outline f-24 mr-2"></i> Após efetuar a instalação, efetue o processo de verificação novamente
          <button (click)="refazerValidacaoWebSoket()" class="btn btn-outline-success btn-xs fw-700 px-2 mx-1">clicando aqui</button>
        </div>

      </ng-container>

    </div>
  </div>

</section>